export const entityCopy = {
  coverageFile: {
    singular: 'coverage file',
    plural: 'coverage files',
    title: 'Coverage File',
    pluralTitle: 'Coverage Files',
  },
  coverageRun: {
    singular: 'coverage run',
    plural: 'coverage runs',
    title: 'Coverage Run',
    pluralTitle: 'Coverage Runs',
  },
  codeDirectory: {
    singular: 'code directory',
    plural: 'code directories',
    title: 'Code Directory',
    pluralTitle: 'Code Directories',
  },
  codeFile: {
    singular: 'code file',
    plural: 'code files',
    title: 'Code File',
    pluralTitle: 'Code Files',
  },
  directory: {
    singular: 'directory',
    plural: 'directories',
    title: 'Directory',
    pluralTitle: 'Directories',
  },
  executionRun: {
    singular: 'execution run',
    plural: 'execution runs',
    title: 'Execution Run',
    pluralTitle: 'Execution Runs',
  },
  feature: {
    singular: 'feature',
    plural: 'features',
    title: 'Feature',
    pluralTitle: 'Features',
  },
  file: {
    singular: 'file',
    plural: 'files',
    title: 'File',
    pluralTitle: 'Files',
  },
  job: {
    singular: 'job',
    plural: 'jobs',
    title: 'Job',
    pluralTitle: 'Jobs',
  },
  jobRun: {
    singular: 'job run',
    plural: 'job runs',
    title: 'Job Run',
    pluralTitle: 'Job Runs',
  },
  pipeline: {
    singular: 'pipeline',
    plural: 'pipelines',
    title: 'Pipeline',
    pluralTitle: 'Pipelines',
  },
  pipelineRun: {
    singular: 'pipeline run',
    plural: 'pipeline runs',
    title: 'Pipeline Run',
    pluralTitle: 'Pipeline Runs',
  },
  project: {
    singular: 'project',
    plural: 'projects',
    title: 'Project',
    pluralTitle: 'Projects',
  },
  release: {
    singular: 'release',
    plural: 'releases',
    title: 'Release',
    pluralTitle: 'Releases',
  },
  resultsFile: {
    singular: 'results file',
    plural: 'results files',
    title: 'Results File',
    pluralTitle: 'Results Files',
  },
  role: {
    singular: 'role',
    plural: 'roles',
    title: 'Role',
    pluralTitle: 'Roles',
  },
  stage: {
    singular: 'stage',
    plural: 'stages',
    title: 'Stage',
    pluralTitle: 'Stages',
  },
  stageRun: {
    singular: 'stage run',
    plural: 'stage runs',
    title: 'Stage Run',
    pluralTitle: 'Stage Runs',
  },
  stageExecution: {
    singular: 'stage execution',
    plural: 'stage executions',
    title: 'Stage Execution',
    pluralTitle: 'Stage Executions',
  },
  suite: {
    singular: 'suite',
    plural: 'suites',
    title: 'Suite',
    pluralTitle: 'Suites',
  },
  suiteRun: {
    singular: 'suite run',
    plural: 'suite runs',
    title: 'Suite Run',
    pluralTitle: 'Suite Runs',
  },
  tag: {
    singular: 'tag',
    plural: 'tags',
    title: 'Tag',
    pluralTitle: 'Tags',
  },
  test: {
    singular: 'test',
    plural: 'tests',
    title: 'Test',
    pluralTitle: 'Tests',
  },
  testRun: {
    singular: 'test run',
    plural: 'test runs',
    title: 'Test Run',
    pluralTitle: 'Test Runs',
  },
  token: {
    singular: 'token',
    plural: 'tokens',
    title: 'Token',
    pluralTitle: 'Tokens',
  },
  upload: {
    singular: 'upload',
    plural: 'uploads',
    title: 'Upload',
    pluralTitle: 'Uploads',
  },
  user: {
    singular: 'user',
    plural: 'users',
    title: 'User',
    pluralTitle: 'Users',
  },
  workspace: {
    singular: 'workspace',
    plural: 'workspaces',
    title: 'Workspace',
    pluralTitle: 'Workspaces',
  },
} as const;

export type EntityCopyKey = keyof typeof entityCopy;

export const getEntityLabel = (
  entity: EntityCopyKey,
  options?: { case?: 'sentence' | 'title'; plural?: boolean },
): string => {
  const copy = entityCopy[entity];
  const labelOptions = options ?? {};
  const useTitleCase = labelOptions.case === 'title';
  const usePlural = labelOptions.plural === true;

  if (useTitleCase) {
    return usePlural ? copy.pluralTitle : copy.title;
  }

  return usePlural ? copy.plural : copy.singular;
};
